import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

/**
 * Central Google Analytics 4 (GA4) configuration for the assessment app.
 *
 * Mirrors the interview tool's `Analytics.js` pattern, but:
 *  - sends data to Google Analytics 4 (not Mixpanel)
 *  - reads the Measurement ID from the CRA env var REACT_APP_GA_MEASUREMENT_ID
 *
 * Usage elsewhere:
 *   import analytics from 'services/config/analytics'
 *   analytics.page()                         // pageview
 *   analytics.identify(userId, { orgId })    // identify candidate (id, not PII)
 *   analytics.track('event_name', { ...props })
 *
 * If REACT_APP_GA_MEASUREMENT_ID is missing (e.g. an env where GA isn't set up),
 * analytics runs as a no-op so the app never breaks.
 */

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID

const isEnabled = Boolean(measurementId)

const analytics = Analytics({
  app: 'Unberry Assessment',
  debug: process.env.REACT_APP_ENV !== 'prod',
  plugins: isEnabled
    ? [
        googleAnalytics({
          measurementIds: [measurementId],
        }),
      ]
    : [],
})

if (!isEnabled) {
  // eslint-disable-next-line no-console
  console.warn(
    '[analytics] REACT_APP_GA_MEASUREMENT_ID not set — GA4 tracking is disabled (no-op).'
  )
}

export default analytics
